"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormLabelDescription = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _spacing = require("../../../constants/spacing");
var _typography = require("../../typography");
var _FormLabelLabel = require("./FormLabelLabel");
const descriptionStyles = (0, _sdsThemeInternal.themed)({
  color: (0, _designTokensReact.color)("color--text--neutral--weak"),
  marginTop: {
    default: {
      "lodestar-light": _spacing.sizes.xxSmall,
      "ursa-light": 0
    },
    afterLabel: {
      "lodestar-light": _spacing.sizes.xxSmall,
      "ursa-light": 3
    }
  }
});
const FormLabelDescription = (0, _styled.default)(_typography.TypeRampV2)`
    color: ${_ref => {
  let {
    themeMode
  } = _ref;
  return descriptionStyles.color(themeMode);
}};
    &:not(:empty) {
        margin-bottom: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _FormLabelLabel.labelStyles.margin(themeMode);
}}px;
        margin-top: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return descriptionStyles.marginTop.default(themeMode);
}}px;
        label + & {
            margin-top: -${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return descriptionStyles.marginTop.afterLabel(themeMode);
}}px;
        }
    }
`;
exports.FormLabelDescription = FormLabelDescription;
//# sourceMappingURL=FormLabelDescription.js.map